import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { fetchMyPremiumTrialsQueryOptions } from "services/trialsService/queries";
import { getXpQueryOptions } from "services/xpService/queries";

import { fetchMyPremiumTrialsIfNotFetched } from "seneca-common/features/premium-trials/service";
import { isSignedIn } from "seneca-common/features/user/state";
import { usePrefetchQueryOnCondition } from "seneca-common/utils/reactQuery/utils";

import ActivateAssignmentNotificationsModalRedirect from "features/notifications/components/activation/ActivateAssignmentNotificationsModalRedirect";
import GlobalSignUpModal from "features/sign-up/global-sign-up-modal";

import ClassroomSubRouter from "./routes/SubRouter";

export default function ClassroomRouter() {
  const signedIn = useSelector(isSignedIn);
  const dispatch = useDispatch();

  usePrefetchQueryOnCondition(fetchMyPremiumTrialsQueryOptions(), signedIn);
  usePrefetchQueryOnCondition(getXpQueryOptions(), signedIn);

  useEffect(() => {
    if (signedIn) {
      dispatch(fetchMyPremiumTrialsIfNotFetched());
    }
  }, [signedIn, dispatch]);

  return (
    <>
      <GlobalSignUpModal />
      <ClassroomSubRouter />
      <ActivateAssignmentNotificationsModalRedirect />
    </>
  );
}
